module.exports = __webpack_public_path__ + "static/mehtaab-and-azaad-brar-e8d14a5e5383a398614969b8b27e6a59.jpg";